import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EscUserProfile = class EscUserProfile extends Snappy.BaseComponent {
    static get tagName() {
        return 'esc-profile-hero';
    }
    constructor(element) {
        super(element);
    }

    render() {
        let wrapper = $(".esc-profile-hero");
        $(document).ready(function () {
            escProfileHero.init(wrapper);
            //Added To focus on Membership history
            if (window.location.href.indexOf('#esc-history') > 0) {
                var evt = new Object();
                evt.currentTarget = $('#esc-history')[0];
                //openCity(evt, "esc-membership-history");
            }
            /*** Clearable text inputs*/
            $(".clearable").each(function () {
                var $inp = $(this).find("input:text"), $cle = $(this).find(".clearable__clear");
                $inp.on("input", function () {
                    $cle.toggle(!!this.value);
                });
                $cle.on("touchstart click", function (e) {
                    e.preventDefault();
                    $inp.val("").trigger("input");
                });
            });
            /*** Autocomplete search in DOM*/
            $('.autocomplete-dom-search input[type=text]').each(function () {
                $(this).on("input", function () {
                    let searchTxt = $(this).val().toLowerCase();
                    if (($(this).attr('id') != "txtShirtNumber" && searchTxt.length >= 3) || $(this).attr('id') == "txtShirtNumber") {
                        $(this).closest('.autocomplete-dom-search').find('ul:first li').each(function () {
                            //debugger;
                            if (($(this).find('span').text().toLowerCase().indexOf(searchTxt) != -1)) {
                                $(this).closest('ul').css('display', 'block');
                                $(this).removeClass('hide');
                            }
                            else {
                                $(this).addClass('hide');
                            }
                        });
                        if ($(this).closest('.autocomplete-dom-search').find('ul:first li:not(.hide)').length == 0) {
                            $(this).closest('ul').css('display', 'block');
                        }
                    }
                    if (searchTxt.length == 0) {
                        $(this).closest('.autocomplete-dom-search').find('ul:first li').addClass('hide');
                        $(this).closest('.autocomplete-dom-search').find('ul:first').css('display', 'none');
                    }
                });
            });
        });

        var escProfileHero = function () {
            var AvailableShirtsModel = {}, DefaultTShirtModel = {}, ShirtChangesModel = {
                ShirtBackGroundImage: "", ShirtName: "", ShirtNumber: "", ShirtNumberInt: 1, Numbers: {}
            };
            var favPlayerAnswerModel = {}, favClubAnswerModel = {};

            var _init = function (ref) {
                $(ref).find($("#esc-edit-player")).click(function () {
                    editPlayerFunction(this);
                });
                $(ref).find($('.doneEditPlayer')).click(function () {
                    doneEditPlayerFunction(ref);
                });

                $(ref).find($('.editshirtdetails')).click(function () {
                    showEditButton();
                });
                $(ref).find($('.donewithedit')).click(function () {
                    showDoneButton(ref);
                });
                //$(".esc-history").click(function () {
                //    getMembership(this);
                //    //HttpService.httpGet("escprofile/getmembershiphistory", 'json','json');
                //});
                //******************** bind change-tshirt options ******************
                bindAvailableChangeShirt(ref);
                bindDefaultShirt(ref);
                $(ref).find('.esc-choose-shirt .esc-change-shirt li').on('click', function () {
                    changeTShirt(this);
                });
                populateShirtNumbers();
                $('.esc-editnumber-modal ul li').on('click', function () {
                    let tShirtNumber = $(this).find('span').text();
                    if (ShirtChangesModel.Numbers.length > 0) {
                        $(wrapper).find('.england-team-numbers').html('');
                        setShirtNumber(tShirtNumber);
                    }
                    escEditNumbertoggleModal();//********* close modal *****
                });
                $('.esc-modal ul li').on('click', function () {
                    let name = $(this).find('span').text();
                    let firstLastName = name.split(' ');
                    ShirtChangesModel.ShirtName = (firstLastName.length > 1) ? firstLastName[1] : firstLastName[0];
                    if (ShirtChangesModel.ShirtName.length > 16) { ShirtChangesModel.ShirtName = ShirtChangesModel.ShirtName.substr(0, 16); }
                    $(wrapper).find('.esc-player-tshirt-buttons span').attr('data-tshirt-name', ShirtChangesModel.ShirtName).text(ShirtChangesModel.ShirtName);
                    toggleModal();//********* close modal *****
                });
                $('.esc-favplayer-modal ul li').on('click', function () {
                    let playerfirstLastName = $(this).find('span').text();
                    favPlayerAnswerModel.Answer = playerfirstLastName;
                    $(wrapper).find('.profile-header__details span.editfavplayer').text(favPlayerAnswerModel.Answer);
                    escFPlayertoggleModal();//********* close modal *****
                });
                window.EscAutoCompleteSelect = {
                    FavoriteClub: function (clubname) {
                        favClubAnswerModel.Answer = clubname;
                        $(wrapper).find('.profile-header__details span.editfavclub').text(favClubAnswerModel.Answer);
                        escFClubtoggleModal();//********* close modal *****
                    }
                };
            },
                setShirtNumber = function (number) {
                    ShirtChangesModel.ShirtNumber = "";
                    let numbers = number.split('');

                    for (var i = 0; i < numbers.length; i++) {
                        let numberImg = ShirtChangesModel.Numbers.filter(function (number) { return number.Name.indexOf(numbers[i]) === 0; });
                        $(wrapper).find('.england-team-numbers').append(`<img class="esc-tshirt-number" src="${numberImg[0].Path}" alt="number" />`);
                        ShirtChangesModel.ShirtNumber = ShirtChangesModel.ShirtNumber + numberImg[0].Id + "|";
                    }
                    ShirtChangesModel.ShirtNumber = ShirtChangesModel.ShirtNumber.substr(0, ShirtChangesModel.ShirtNumber.length - 1);
                    ShirtChangesModel.ShirtNumberInt = number;
                    $(wrapper).find('.esc-choose-shirt #hdnDefaultNumber').val(number);
                },
                populateShirtNumbers = function () {
                    if ($('.esc-editnumber-modal ul li').length == 0) {
                        for (var i = 1; i <= 99; i++) {
                            $('.esc-editnumber-modal ul:first').append(`<li class="ui-menu-item"><span class="ui-menu-item-wrapper">${i}</span></li>`);
                        }
                    }
                },
                bindAvailableChangeShirt = function (ref) {
                    AvailableShirtsModel = JSON.parse($(ref).find('.esc-choose-shirt #hdnAvailableShirts').val());
                    $.each(AvailableShirtsModel, function (index, value) {
                        let template = `<li tabindex="0" data-id="${value.Id}" class="esc-pb-65" aria-label="${value.BackgroundShirt.Name} Shirt"><img data=id="${value.BackgroundShirt.Id}" alt="" class="esc-shirt-img" src="${value.BackgroundShirt.Path}" data-pin-nopin="true"/></li>`;
                        $(ref).find('.esc-choose-shirt .esc-change-shirt').append(template);
                    });
                },
                bindDefaultShirt = function (ref) {
                    if ($(ref).find('.esc-choose-shirt #hdnDefaultTShirt').val() != "" && $(ref).find('.profile-header__visuals #currentImg').attr('src') == "") {
                        DefaultTShirtModel = JSON.parse($(ref).find('.esc-choose-shirt #hdnDefaultTShirt').val());
                        $(ref).find('.profile-header__visuals #currentImg').attr('src', DefaultTShirtModel.BackgroundShirt.Path);
                        if (DefaultTShirtModel.Numbers.length == 0) {
                            $(ref).find('.editshirtdetails').hide();
                        }
                        else {
                            ShirtChangesModel.Numbers = DefaultTShirtModel.Numbers;
                            $(ref).find('.editshirtdetails').show();
                        }
                    }
                    else {
                        ShirtChangesModel.ShirtBackGroundImage = $(ref).find('.profile-header__visuals #currentImg').attr('data-tshirt-guid');
                        ShirtChangesModel.ShirtName = $(ref).find('.esc-player-tshirt-buttons span').attr('data-tshirt-name');
                        ShirtChangesModel.ShirtNumber = $(ref).find("#hdnTshirtNumberGuid").length == 0 ? "" : $(ref).find("#hdnTshirtNumberGuid").val();
                        ShirtChangesModel.ShirtNumberInt = $(ref).find("#hdnDefaultNumber").val();
                        let allShirtsModel = JSON.parse($(ref).find('.esc-choose-shirt #hdnAvailableShirts').val());
                        let shirtNumbers = allShirtsModel.filter(function (item) { return item.BackgroundShirt.Id == ShirtChangesModel.ShirtBackGroundImage; });
                        if (shirtNumbers.length > 0) {
                            ShirtChangesModel.Numbers = shirtNumbers[0].Numbers;
                            //******************** Set correct colors for shirt-number & shirt-name *********************
                            let bgShirtPath = $(ref).find('.profile-header__visuals #currentImg').attr('src');
                            if (bgShirtPath.includes("away")) {
                                $(ref).find('.esc-tshirt').addClass("away");
                                $(ref).find('.eng-ms-cta--outline').addClass("white");
                                $(ref).find('.esc-get-tshirt').addClass("blue");
                            } else {
                                $(ref).find('.esc-tshirt').removeClass("away");
                                $(ref).find('.eng-ms-cta--outline').removeClass("white");
                                $(ref).find('.esc-get-tshirt').removeClass("blue");
                            }
                            if (bgShirtPath.includes("women")) {
                                $(ref).find('.esc-tshirt').addClass("women");
                            } else {
                                $(ref).find('.esc-tshirt').removeClass("women");
                            }
                        }
                        else
                            ShirtChangesModel.Numbers = [];
                        if (ShirtChangesModel.ShirtNumber.length == 0) {//**************** If default shirt is saved *********
                            $(ref).find('.profile-header__visuals #currentImg').addClass('fixtures-block__actions_default_shirt');
                        }
                    }
                },
                changeTShirt = function (ref) {
                    let selectedShirt = AvailableShirtsModel.filter(function (item) { return item.Id == $(ref).attr('data-id'); });
                    ShirtChangesModel.ShirtBackGroundImage = selectedShirt[0].BackgroundShirt.Id;
                    ShirtChangesModel.Numbers = selectedShirt[0].Numbers;
                    $(wrapper).find('.england-team-numbers').html('');
                    $(wrapper).find('.profile-header__visuals #currentImg').attr('src', selectedShirt[0].BackgroundShirt.Path);
                    if (selectedShirt[0].BackgroundShirt.Path.includes("away")) {
                        $(wrapper).find('.esc-tshirt').addClass("away");
                        $(wrapper).find('.eng-ms-cta--outline').addClass("white");
                        $(wrapper).find('.esc-get-tshirt').addClass("blue");
                    } else {
                        $(wrapper).find('.esc-tshirt').removeClass("away");
                        $(wrapper).find('.eng-ms-cta--outline').removeClass("white");
                        $(wrapper).find('.esc-get-tshirt').removeClass("blue");
                    }
                    if (selectedShirt[0].BackgroundShirt.Path.includes("women")) {
                        $(wrapper).find('.esc-tshirt').addClass("women");
                    } else {
                        $(wrapper).find('.esc-tshirt').removeClass("women");
                    }
                    if (ShirtChangesModel.Numbers.length > 0) {
                        $(wrapper).find('.esc-player-tshirt-buttons-block').removeClass('hide fixtures-block__actions_default');
                        $(wrapper).find('.profile-header__visuals #currentImg').removeClass('fixtures-block__actions_default_shirt');
                        $(wrapper).find('.england-team-numbers,.editshirtdetails,.get-tshirt').removeClass('hide').show();
                        if ($(wrapper).find('.england-team-numbers').children().length == 0) {
                            setShirtNumber($(wrapper).find('.esc-choose-shirt #hdnDefaultNumber').val());
                        }
                        if ($(wrapper).find('.england-names span').attr('data-tshirt-name') == "") {
                            let userName = $(wrapper).find('.england-names #hdnTShirtLastName').val();
                            $(wrapper).find('.england-names span').removeClass('hide').attr('data-tshirt-name', userName).text(userName);
                            ShirtChangesModel.ShirtName = userName;
                        }
                        else {
                            let userName = $(wrapper).find('.england-names span').removeClass('hide').attr('data-tshirt-name');
                            ShirtChangesModel.ShirtName = userName;
                        }
                        $(wrapper).find('.donewithedit').addClass('hide').removeClass('donewithit-button-default');
                    }
                    else {
                        $(wrapper).find('.editshirtdetails,.get-tshirt').hide();
                        $(wrapper).find('.profile-header__visuals #currentImg').addClass('fixtures-block__actions_default_shirt');
                        $(wrapper).find('.esc-player-tshirt-buttons-block').addClass('fixtures-block__actions_default');
                        $(wrapper).find('.esc-player-tshirt-buttons-block').removeClass('hide');
                        $(wrapper).find('.donewithedit').removeClass('hide').addClass('donewithit-button-default');
                        $(wrapper).find('.england-team-numbers').hide();
                        $(wrapper).find('.england-names span').attr('data-tshirt-name', "").text("");
                        ShirtChangesModel.ShirtName = "";
                        ShirtChangesModel.ShirtNumber = "";
                    }
                    $(".esc-edit-tshirt-name,.esc-edit-number").addClass("hide");
                    $(ref).closest('ul').find('li img').removeClass('add-red-circle');
                    $(ref).find('img').addClass('add-red-circle');
                    //console.log("On Change:" + JSON.stringify(ShirtChangesModel));
                },
                editPlayerFunction = function (button) {
                    //var x = document.getElementsByClassName("editplayer");
                    //var playerEditList, index;
                    //playerEditList = document.getElementsByClassName("editplayer");
                    //for (index = 0; index < playerEditList.length; ++index) {
                    //    playerEditList[index].setAttribute('contentEditable', 'true');
                    //}
                    //if (x.contentEditable == "true") {
                    //    x.contentEditable = "false";
                    //    button.innerHTML = "Edit";
                    //} else {
                    //    x.contentEditable = "true";
                    //    button.innerHTML = "Done";
                    //}
                    //var text = $('.editplayer').text();
                    //var input = $('<input id="escattribute" type="text" value="' + text + '" />')
                    //$('.editplayer').text('').append(input);
                    //input.select();
                    //input.blur(function () {
                    //    var text = $('#escattribute').val();
                    //    $('#escattribute').parent().text(text);
                    //    $('#escattribute').remove();
                    //});
                    $(".esc-edit-favclub").removeClass("hide");
                    $(".esc-edit-favplayer").removeClass("hide");
                    $(".esc-editbutton").addClass("hide");
                    $(".doneEditPlayer").removeClass("hide");
                    $(".esc-edit-favclubpencile").addClass("hide");
                },
                doneEditPlayerFunction = function (ref) {
                    $(".esc-edit-favclub").addClass("hide");
                    $(".esc-edit-favplayer").addClass("hide");
                    $(".esc-editbutton").removeClass("hide");
                    $(".doneEditPlayer").addClass("hide");
                    $(".esc-edit-favclubpencile").removeClass("hide");

                    let _data = [];
                    _data.push({ AttributeName: "FAVPLAYER", Answer: favPlayerAnswerModel.Answer });
                    _data.push({ AttributeName: "FAVCLUB", Answer: favClubAnswerModel.Answer });
                    HttpService.httpPost($(wrapper).attr('data-url'), { answers: _data }, function (data) {
                        if (!data.success) {
                            alert(data.error);
                        }
                    }, function (data) {
                        //debugger;
                    }, ref);
                },

                showEditButton = function () {
                    $(".esc-edit-tshirt-name").removeClass("hide");
                    $(".esc-edit-number").removeClass("hide");
                    $(".donewithedit").removeClass("hide");
                    $(".editshirtdetails").addClass("hide");
                    $(".get-tshirt").addClass("hide");
                },
                showDoneButton = function (ref) {
                    let _data = [];
                    //console.log("On Change:" + JSON.stringify(ShirtChangesModel));
                    if (ShirtChangesModel.ShirtNumberInt < 100 && ShirtChangesModel.ShirtNumber != "") {
                        ShirtChangesModel.ShirtBackGroundImage = ShirtChangesModel.ShirtBackGroundImage + "#" + ShirtChangesModel.ShirtNumber;
                    }
                    else {
                        //****************** for default logo-shirt only[shirt number will not be shown] ******************
                        ShirtChangesModel.ShirtNumberInt = 1;
                    }
                    _data.push({ AttributeName: "PROFILEIMAGE", Answer: ShirtChangesModel.ShirtBackGroundImage });
                    _data.push({ AttributeName: "SHIRTNUMBER", Answer: ShirtChangesModel.ShirtNumberInt });
                    _data.push({ AttributeName: "SHIRTCAPTION", Answer: ShirtChangesModel.ShirtName });
                    HttpService.httpPost($(wrapper).attr('data-url'), { answers: _data }, function (data) {
                        if (!data.success) {
                            console.log(data.error);
                        }
                        else {
                            clearEditMode();
                            updateProfileNav();
                        }
                    }, function (data) {
                        //debugger;
                    }, ref);
                },
                clearEditMode = function () {
                    if (ShirtChangesModel.ShirtNumber != "") {
                        $(".editshirtdetails,.get-tshirt").removeClass('hide').show();
                    }
                    $(".donewithedit").addClass("hide");
                    $(".esc-edit-tshirt-name,.esc-edit-number").addClass("hide");
                },
                updateProfileNav = function () {
                    let tshirtSrc = $(wrapper).find('.profile-header__visuals #currentImg').attr('src');
                    let numbers = "";
                    let tshirtNumbers = $(wrapper).find('.england-team-numbers img');
                    if (tshirtNumbers != undefined) {
                        if (tshirtNumbers.length == 1) {
                            numbers = `<img style="margin-left:3px;" class="esc-tshirt-number" src="${$(tshirtNumbers[0]).attr('src')}" alt="number" />`;
                        }
                        else if (tshirtNumbers.length == 2)
                            numbers = `<img class="esc-tshirt-number" src="${$(tshirtNumbers[0]).attr('src')}" alt="number" /><img class="esc-tshirt-number" src="${$(tshirtNumbers[1]).attr('src')}" alt="number" />`;
                    }
                    let tshirtName = $(wrapper).find('.esc-player-tshirt-buttons span').text();
                    let showHide = (numbers == "") ? "hide" : "";
                    let menWoman = (tshirtSrc).includes("away") ? "away" : (tshirtSrc).includes("women") ? "women" : "";
                    $('.menssenior-escmaincontainer.fa-navigation .nav-image-shirt').each(function () {
                        $(this).html(`<div class="profile-header__visuals home-page esc-tshirt ${menWoman}">
                                        <img src="${tshirtSrc}" id="currentImg" alt="profile-shirt" class="profile-header__visuals-headshot" />
                                        <div class="fixtures-block__actions esc-player-tshirt-buttons">
                                            <div class="england-names">
                                                <span class="esc-font-size-4 ${showHide}" data-tshirt-name="${tshirtName}">${tshirtName}</span>
                                                <div class="england-team-numbers ${showHide}">
                                                    ${numbers}
                                                </div>
                                        </div>
                                        </div>
                                    </div>`);
                    });
                };
            return {
                init: _init
            };

        }();
        //***************** method to get request-security token **********************
        var CommonMethods = function () {
            var _getVerificationToken = function getVerificationToken(form) {
                return form.find('input[name=__RequestVerificationToken]').val();
            };
            return {
                getVerificationToken: _getVerificationToken
            };
        }();

        //******* Event registered to handle HTTP-POST & HTTP-GET *******
        var HttpService = function () {
            var _httpGet = function (serviceName, successCallback, errorCallback, sender) {

                //var headers = {
                //    "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                //};
                $.ajax({
                    url: '/api/sitecore/' + serviceName,
                    type: "GET",
                    //dataType: 'json',
                    //headers: headers,
                    cache: false,
                    beforeSend: function () {
                    },
                    success: function (data) {
                        successCallback(data, sender);
                    },
                    error: function (jqXHR, status, errorMessage) {
                        errorCallback(jqXHR);
                    },
                    complete: function () {
                    }
                });
            },
                _httpPost = function (serviceName, dataInput, successCallback, errorCallback, sender) {
                    //var headers = {
                    //    "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                    //};
                    //debugger;
                    $.ajax({
                        url: '/api/sitecore/' + serviceName,
                        type: "POST",
                        dataType: 'json',
                        data: JSON.stringify(dataInput),
                        //headers: headers,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function () {
                        },
                        success: function (data) {
                            successCallback(data, sender);
                        },
                        error: function (jqXHR, status, errorMessage) {
                            errorCallback(jqXHR);
                        },
                        complete: function () {
                        }
                    });
                };
            return {
                httpPost: _httpPost,
                httpGet: _httpGet
            };
        }();
    };
}



// WEBPACK FOOTER //
// ./components/eng-ms-escprofile/scripts/esc-profile.js